import React from "react";
import { AllProgressCheckStatuses, IEvidence, ProgramData, ProgressCheck } from "@interfaces/Interfaces";
import ProgramEvidenceCard from "./ProgramEvidenceCard";
import * as ProgramUtils from "@utils/programUtils";
import { useRecoilValueLoadable } from "recoil";
import { evidenceAtom, progressCheckDataAtom } from "@state/State";
import ProgramInfoCard from "@components/home/ProgramInfoCard";

type Props = {
  evidence: IEvidence[];
  program: ProgramData;
  progressChecks: ProgressCheck[];
  evidenceCardPressed: (evidence: IEvidence) => void;
};

const ProgramEvidenceList: React.FC<Props> = (props) => {
  const allProgressCheckData = useRecoilValueLoadable<AllProgressCheckStatuses[] | null>(progressCheckDataAtom);
  const allEvidence = useRecoilValueLoadable<IEvidence[] | null>(evidenceAtom);

  if (!ProgramUtils.isSPAPRP(props.program.ID) && !ProgramUtils.isNwasARC(props.program.ID)) {
    return null;
  }

  return (
    <ProgramInfoCard
      title="Evidence list"
      subTitle={props.evidence.length === 0 ? "Any evidence added will appear below." : undefined}
    >
      {props.evidence.map((evidence) => (
        <ProgramEvidenceCard
          key={evidence.id}
          buttonPressed={() => props.evidenceCardPressed(evidence)}
          programEvidence={evidence}
          program={props.program}
          progressCheckLocked={
            ProgramUtils.isNQPProgram(props.program.ID) &&
            ProgramUtils.isProgramCompleteNQP(
              props.progressChecks,
              allProgressCheckData.contents,
              allEvidence.contents,
              props.program?.ID
            )
          }
        />
      ))}
    </ProgramInfoCard>
  );
};

export default ProgramEvidenceList;
